export default __webpack_public_path__ + "static/media/card_area.435f48c3.svg";